// extracted by mini-css-extract-plugin
module.exports = {"episode":"EpisodeNumber_episode__j8Kwy","big":"EpisodeNumber_big__sdUiD","small":"EpisodeNumber_small__tqF32"};